// extracted by mini-css-extract-plugin
export default {"login":"login--VuS6s","content":"content--E5joI","title":"title--SXRVo","subTitle":"subTitle--B3gYO","loginGoogleBtn":"loginGoogleBtn--wcx5r","guestBtn":"guestBtn--vJ8IF"};